import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_PUBLIC_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_PUBLIC_SUPABASE_ANON_KEY;


export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        autoRefreshToken: true,
        storage: localStorage,
        persistSession: true,
        cookieOptions: {
            name: 'supabase-auth-token',
            lifetime: 60 * 60 * 24 * 30, // 30 days
            domain: window.location.hostname,
            path: '/',
            sameSite: 'lax',
        }
    }
});